import urlJoin from "url-join";
import { httpPostSimple } from "./makeRequest.js";
/**
 * Asks the server to fetch the pipeline definition corresponding to the
 * given pipeline ID. Requires cookies, as this is part of generic issuance
 * user authentication.
 */
export async function requestGenericIssuanceGetAllUserPipelines(zupassServerUrl, jwt) {
    return httpPostSimple(urlJoin(zupassServerUrl, `/generic-issuance/api/get-all-user-pipelines`), async (resText) => ({
        value: JSON.parse(resText),
        success: true
    }), {
        jwt
    }, true);
}
